import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import AccordionItem from './AccordionItem.js';
import { AccordionWrapper, ButtonGroup, Button } from './Accordion.styles.js';

/**
 * Accordion creates an accessible interactive group of items that are toggled when clicking on.
 * The `items` prop expects an array of objects. Each object is then converted into
 * an `AccordionItem` component.
 */
var Accordion = function Accordion(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$spanish = _ref.spanish,
    spanish = _ref$spanish === void 0 ? false : _ref$spanish,
    _ref$requestId = _ref.requestId,
    requestId = _ref$requestId === void 0 ? '' : _ref$requestId;
  var _useState = useState(Array(items.length).fill(false)),
    _useState2 = _slicedToArray(_useState, 2),
    openItems = _useState2[0],
    setOpenItems = _useState2[1];
  var numberOpen = openItems.reduce(function (acc, currItem) {
    return currItem === true ? acc + 1 : acc;
  }, 0);
  var openOrCloseAll = function openOrCloseAll(event) {
    if (event.type === 'click' || event.type === 'keydown' && event.key === 'Enter') {
      /* check if open all or close all button called this function through data attributes
       * they are called data-open with boolean values because that is what we want to store
       * in the item array state
       */
      var dataOpen = event.target.dataset.open === 'true';
      var newOpenItems = _toConsumableArray(openItems).fill(dataOpen);
      setOpenItems(newOpenItems);
    }
  };
  var handleOpen = function handleOpen(index) {
    var newOpenItems = _toConsumableArray(openItems);
    newOpenItems[index] = !newOpenItems[index];
    setOpenItems(newOpenItems);
  };
  return /*#__PURE__*/React__default.createElement(AccordionWrapper, {
    className: "leshen-accordion"
  }, items.length > 3 && /*#__PURE__*/React__default.createElement(ButtonGroup, {
    className: "button-group"
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: "button",
    type: "button",
    "data-open": "true",
    onClick: openOrCloseAll,
    onKeyDown: openOrCloseAll,
    disabled: numberOpen === openItems.length
  }, spanish ? 'Expandir todo' : 'Expand All'), /*#__PURE__*/React__default.createElement(Button, {
    className: "button",
    type: "button",
    "data-open": "false",
    onClick: openOrCloseAll,
    onKeyDown: openOrCloseAll,
    disabled: numberOpen === 0
  }, spanish ? 'Ocultar todo' : 'Collapse All')), items.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(AccordionItem, {
      className: "item-wrapper",
      key: item.title,
      index: index,
      item: item,
      isOpen: openItems[index],
      handleOpen: handleOpen,
      requestId: requestId
    });
  }));
};
var Accordion$1 = Accordion;

export { Accordion$1 as default };
//# sourceMappingURL=index.js.map
